import styles from "styles/components/seedIcon.module.scss";

const SeedIcon = () => <span className={styles.wrapper}>🌱</span>;

export default SeedIcon;
